import { gql, type TypedDocumentNode } from "@apollo/client";
import { CRM_NOTE_FIELDS_FRAGMENT } from "@/fragments";
import type { CRMNote } from "@/types";
import type {
  FacilityGovernancePerson,
  GovernanceTitle
} from "@/pages/facilities/[facilityId]/people/governance/types";

export type SectionGovernanceTargetType = "SECTION" | "NATIONAL";

export interface SectionGovernanceRoleNode {
  id: string;
  status: string;
  title: GovernanceTitle;
  person: FacilityGovernancePerson;
  notes: CRMNote[];
}

export interface SectionGovernanceRolesQueryData {
  section: {
    id: string;
    name: string;
    legacyId: string | null;
    governanceRoles: SectionGovernanceRoleNode[];
  } | null;
}

export interface SectionGovernanceRolesQueryVariables {
  sectionId: string;
}

export const SECTION_GOVERNANCE_ROLES_QUERY: TypedDocumentNode<
  SectionGovernanceRolesQueryData,
  SectionGovernanceRolesQueryVariables
> = gql`
  query SectionGovernanceRoles($sectionId: ID!) {
    section(id: $sectionId) {
      id
      name
      legacyId
      governanceRoles {
        id
        status
        title {
          id
          title
        }
        person {
          id
          displayName
          pgaId
          profilePhoto
          latestProgram {
            programType {
              id
              name
            }
          }
        }
        notes {
          ...CRMNoteFields
        }
      }
    }
  }
  ${CRM_NOTE_FIELDS_FRAGMENT}
`;

export interface GovernanceTitlesQueryData {
  governanceTitles: GovernanceTitle[];
}

export interface GovernanceTitlesQueryVariables {
  targetType: SectionGovernanceTargetType;
}

export const GOVERNANCE_TITLES_QUERY: TypedDocumentNode<GovernanceTitlesQueryData, GovernanceTitlesQueryVariables> =
  gql`
    query GovernanceTitles($targetType: BackofficeGovernanceRoleTargetType!) {
      governanceTitles(targetType: $targetType) {
        id
        title
      }
    }
  `;
